import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Button } from '../../Button';
import './Stopwatch.css';

function Stopwatch() {
    const [time, setTime] = useState(0);
    const [running, setRunning] = useState(false);

    useEffect(() => {
        let interval = null;
        if (running) {
            interval = setInterval(() => {
                setTime(prevTime => prevTime + 10)
            }, 10);
        } else {
            clearInterval(interval);
        }

        return () => clearInterval(interval)
    }, [running]);


    return (
        <>
            <Helmet>
                <title>Kai Cheng | Stopwatch</title>
                <meta name='description' content='Kai Cheng | Stopwatch' />
            </Helmet>
            <h1>Stopwatch</h1>
            <section className='resume__container mb-50'>
                <div className='stopwatch'>
                    <div className='mb-20 digits'>
                        <span className='mono' id='min'>{('0' + Math.floor((time / 60000) % 60)).slice(-2)}</span><span className='regular'>:</span>
                        <span className='mono' id='sec'>{('0' + Math.floor((time / 1000) % 60)).slice(-2)}</span><span className='regular'>.</span>
                        <span className='mono' id='msec'>{('0' + (time / 10) % 1000).slice(-2)}</span>
                    </div>
                    <div>
                        <span className='mr-10'>
                            <Button buttonStyle='btn--square' buttonColor={running ? 'red' : 'green'} onClick={() => setRunning(!running)}>
                                {running ? 'Stop' : 'Start'}
                            </Button>
                        </span>
                        <span>
                            <Button buttonStyle='btn--square' buttonColor='orange' onClick={() => { setTime(0); setRunning(false); }}>
                                Reset
                            </Button>
                        </span>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Stopwatch;
